import firebase from 'firebase'
import Firebase, { db } from '../../config/Firebase'
import { Action } from './types'

export const addImagesToQueue = (pictures) => {
    return (dispatch) => {
        pictures.map((image) => {
            dispatch({ type: Action.IMAGE_UPLOAD_QUEUE, payload: image })
        })
        //dispatch({ type: Action.REQUESTS_RESET_IMAGES })
    }
}

export const createQueue = ({currentIndex}) => {
    return (dispatch) => {
        dispatch({ type: Action.IMAGE_CREATE_QUEUE, payload: {currentIndex} })
    }
}

export const addImageToQueue = (pictures) => {
    return (dispatch, getStore) => {
        const { currentIndex } = getStore().requestList
        //pictures.map((image) => {
            //console.log("action image: ", image)
            dispatch({ type: Action.IMAGE_ADD_TO_QUEUE, payload: {currentIndex, pictures} })
        //})
    }
}

export const processUploadQueue = () => {
    return (dispatch, getStore) => {
        const { uploadingQueue } = getStore().images
        dispatch({ type: Action.IMAGES_UPLOADING })
        let uploadQueue = uploadingQueue.map((item, index) => {
            //console.log("item image: ", item)
            const { file } = item.image
            const { requestArray, currentIndex } = getStore().requestList
            const { id, data } = requestArray[currentIndex]
            const userId = data.uid
            const requestId = id
            const ref = Firebase
            .storage()
            .ref()
            .child('images/' + userId + '/requests/' + requestId + '/diagnosis/' + file.name)
            return (
                ref.put(file)
                    .then((snapshot) => {
                        snapshot.ref.getDownloadURL().then(function (downloadURL) {
                            //dispatch({ type: Action.IMAGE_UPLOADED, payload: downloadURL })
                            const databaseRef = db.collection('requests').doc(requestId)
                            databaseRef.update({
                                "diagnosis.images": firebase.firestore.FieldValue.arrayUnion({
                                        url: downloadURL,
                                        file: 'images/' + userId + '/requests/' + requestId + '/diagnosis/' + file.name
                                    })
                                }).then(() => {
                                //console.log("El registro se ingreso")
                                dispatch({ 
                                    type: Action.REQUESTS_UPDATE_DIAGNOSIS_IMAGES, 
                                    payload: {
                                        url: downloadURL,
                                        file: 'images/' + userId + '/requests/' + requestId + '/diagnosis/' + file.name
                                    }
                                })

                            })
                                .catch((error) => {
                                    console.log("error: ", error)
                                })
                        })
                    })
                    .catch((error) => {
                        console.log("error: ", error)
                    })
            )
        })
        return (
            Promise.all(uploadQueue)
            .then (() => {
                dispatch(imagesUploadFInished())
            })
        )
    }
}

export const imagesUploadFInished = () => {
    return (dispatch, getStore) => {
        const { currentIndex } = getStore().requestList
        dispatch({ type: Action.IMAGES_UPLOAD_COMPLETE, payload: currentIndex })
        //dispatch({ type: Action.REQUESTS_RESET_CURRENT_IMAGES })
    }
}